<template>
    <div id="qingming">
        <ul class="list">
            <li @click="active = 26" :class="{active:active == 26}">
                <h2>7700</h2>
                <p>个书币+书豆</p>
                <span>充值38元送39元</span>
            </li>
            <li @click="active = 27" :class="{active:active == 27}">
                <h2>16700</h2>
                <p>个书币+书豆</p>
                <span>充值78元送89元</span>
            </li>
        </ul>
        <p class="tip">活动时间：4月3日 --- 4月6日</p>
        <p class="btn">
            <img src="./../../assets/qingming/btn.png" alt="" @click="doRecharge">

        </p>
    </div>
</template>

<script>
    export default {
        name: "Qingming",
        data(){
            return {
                active:26,
            }
        },methods:{
            doRecharge(){

                let userInfo = this.$store.getters.getUserInfo;
                if(!userInfo.id){
                    this.$router.push({name:"Login",query:{cburl:this.$route.path}});
                    return ;
                }

                var loading = this.$loading({
                    lock: true,
                    text: '充值订单生成中...',
                });
                //先查询用户是否参与过首充优惠
                this.axios.post('/api/recharge/actives',{
                    type : 12,
                    rid : this.active,
                }).then(r => {
                    loading.close()
                    let data = r.data;
                    if(data.code == 0){
                        alert(data.msg);
                    } else if(data.code == 1){
                        location.href= process.env.VUE_APP_API + '/login/getOpenid/?orders=' + data.data.orders;
                    }
                })
            }
        }
    }
</script>

<style lang="less">
#qingming{
    min-height: 1500px;background-image: url("./../../assets/qingming/bg.png");background-size:100% 100%;overflow: auto;position: relative;
    .list{background-image: url("./../../assets/qingming/hd.png");width: 90%;height: 200px;background-size: 100% 100%;margin: 800px auto 0 auto;
        li{float: left;width: 50%;text-align: center;
            h2{font-size: 70px;color: #fff;}
            p{font-size: 24px;color: #fff;}
            span{background: #fdf8e6;font-size:26px;color: #613b28; padding: 0 20px;}
        }
        .active{
            span{background: #f9c404;}
        }

    }
    .tip{color: #fff;text-align: center;font-size: 24px;margin-top: 100px;}
    .btn{text-align:center;margin-top: 80px;
        img{width: 300px;}
    }

}
</style>
